import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-email-template.service";

export const useAdminEmailTemplate = createUseData(
    service.getAdminEmailTemplate,
)